import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class ImportRequests extends BaseAPIModel {
    static listUrl({ organizationId, eventId }) {
        if (!eventId || !organizationId) {
            throw new ArgumentError(`[Model] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/import`;
    }
}
